export const packages = {
  notAssignedPackages:
    'No assigned packages — select one from the list to assign to an option',
  name: 'Name',
  code: 'Code',
  startAt: 'Start date',
  expiresAt: 'Expiration date',
  addingPackage: 'Adding a new package',
  editPackage: 'Edit package',
  assignPackageToOption: 'Packages not assigned to options',
  defaultSelected: 'Selected by default',
  forceSelect: 'Force selection',
  titleFor: 'Packages for configuration template ',
  addNew: 'Add new package',
  options: 'Options assigned to package',
  linkOption: 'Assign option',
  unLinkOption: 'Remove assignment',
  unLinkOptionConfirmation:
    'You are removing the assignment of option "{label}" from the package. Do you want to continue?',
  selectOption: 'Select option...',
  noOptions: 'No assigned options',
  linkedOption: 'Assigned a new option to package',
  assignmentValue: 'Option value',
  assignmentValueRequired: 'Provide a valid option value.',
  assignmentValuePlaceholderNumber: 'Enter numeric value',
  unlinkedOption: 'Removed option assignment from package',
  deletePackage: 'Delete package',
  deletedQuestion:
    'Are you sure you want to delete the package "{packageName}"?',
  packageDeleteSuccess: 'Package has been successfully deleted',
  managePackagesDescription:
    'Manage packages and edit their assignment settings used across options.',
  flowNotFound: 'Flow not found.',
  applyPackage: 'Package was applied',
}
